import React, { useEffect, useState } from "react";

import GoatFightHeader from "../components/home-page/HomePageHeader";
import GoatFightFooter from "../components/home-page/HomePageFooter";

import HeroSection from "../components/home-page/HeroSection";
import HowItWorks from "../components/home-page/HowItWorks";
import LiveSimulatedGame from "../components/home-page/LiveSimulatedGame";
import UpcomingMatchups from "../components/home-page/UpcomingMatchups";
import Benefits from "../components/home-page/Benefits";
import HomeCTA from "../components/home-page/HomeCTA";

import "../assets/css/goatfight-home.css";
import { Container } from "react-bootstrap";

import { CRUDServices } from "../services/CRUDServices";
import { objectToFormData } from '../functions';

const GoatFightHome = () => {

    const [fantasyTeamDetailExchange, setFantasyTeamDetailExchange] =  useState([]);
    const [loading, setLoading] = useState(false);

    const getFantasyTeamDetailExchange = async (date) => {

        setLoading(true);

        const payload = objectToFormData({ exchange_slug: "nba", api_username: "FANDEX_DEV_TEAM", api_password: "FANDEX_PASSWORD_@#", date: date,});

        try {

            const response = await CRUDServices.POST("get_fantasy_team_detail_exchange",  payload);
            console.log(response, "response");

            if (response.status === 200) {
                setFantasyTeamDetailExchange(  response?.data?.data || []);

            } else {
                setFantasyTeamDetailExchange([]);

            }

        } catch (error) {
            console.error(   "getFantasyTeamDetailExchange error:", error);
            setFantasyTeamDetailExchange([]);

        } finally {

            setLoading(false);

        }
    };


    /*
     * Get today's date
     *
     * API expects date.
     */
    useEffect(() => {

        const today = new Date();

        const year = today.getFullYear();

        const month = String(
            today.getMonth() + 1
        ).padStart(2, "0");

        const day = String(
            today.getDate()
        ).padStart(2, "0");

        const date = `${year}-${month}-${day}`;

        getFantasyTeamDetailExchange(date);

    }, []);


    return (
        <>
            <main className="goatfight-home">
                <GoatFightHeader />

                <HeroSection />

                <HowItWorks />

                <Container>
                    <section className="shell game-grid">
                        <LiveSimulatedGame fantasyTeamDetailExchange={fantasyTeamDetailExchange}loading={loading}/>
                        <UpcomingMatchups fantasyTeamDetailExchange={fantasyTeamDetailExchange}/>
                    </section>
                </Container>

                <Benefits />

                <HomeCTA />
                <GoatFightFooter />
            </main>
        </>
    );
};

export default GoatFightHome;